module.exports = __webpack_public_path__ + "static/img/site-footer-mape.a1919ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/site-footer-mape.png
// module id = zlFm
// module chunks = 39